export default "__VITE_ASSET__CoEgr3lC__"